import styled from "styled-components";

export const Wrapper = styled.div`
  p {
    font-family: "Poppins" !important;
    font-weight: 600 !important;
    font-size: 19px !important;
    color: var(--color-dark) !important;
  }
`;
